<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="container border rounded" style="background-color:powderblue;">
      <div class="row justify-content-md-center">
        {{Item.Prezime}}&nbsp;{{Item.Ime}}
      </div>
    </div>

    <div class="row tabs-cont" #tabsCont>
      <div class="col-md-12 h-100">
          <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false">
              <ngb-tab 
                title="{{'OSOBA.BASIC'| translate}}" id="tbList">
                  <ng-template ngbTabContent>
                    <div class="form-group row">
                      <div class="col-md-6">
                        <yt-input
                          #autofocus
                          [Type]="'text'" name="txtPrezime" formControlName="Prezime" [MaxLength]="50"
                          [ngClass]="{'is-invalid': submitted && fc.Prezime.invalid}" [Label]="'OSOBA.PREZIME.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Prezime.invalid">
                          <span *ngFor="let validation of errorMessages.Prezime">
                            <span class="error-message" *ngIf="fc.Prezime.hasError(validation.type)">
                              <span translate="{{validation.message}}"></span>
                            </span>
                          </span>
                        </div>
                      </div>                      
                      <div class="col-md-6">
                        <yt-input
                          [Type]="'text'"
                          name="txtIme"
                          formControlName="Ime"
                          [MaxLength]="50"
                          [ngClass]="{'is-invalid': submitted && fc.Ime.invalid}" [Label]="'OSOBA.IME.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Ime.invalid">
                          <span *ngFor="let validation of errorMessages.Ime">
                            <span class="error-message" *ngIf="fc.Ime.hasError(validation.type)">
                              <span translate="{{validation.message}}"></span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-md-6">
                        <yt-input [Type]="'text'" name="txtDevojacko" formControlName="Devojacko"
                          [ngClass]="{'is-invalid': submitted && fc.Devojacko.invalid}" [Label]="'OSOBA.DEVOJACKO.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.Devojacko.invalid">
                          <span *ngFor="let validation of errorMessages.Devojacko">
                            <span class="error-message" *ngIf="fc.ImeOca.hasError(validation.type)">
                              <span translate="{{validation.message}}"></span>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <yt-input [Type]="'text'" name="txtImeOca" formControlName="ImeOca"
                          [ngClass]="{'is-invalid': submitted && fc.ImeOca.invalid}" [Label]="'OSOBA.IMEOCA.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="submitted && fc.ImeOca.invalid">
                          <span *ngFor="let validation of errorMessages.ImeOca">
                            <span class="error-message" *ngIf="fc.ImeOca.hasError(validation.type)">
                              <span translate="{{validation.message}}"></span>
                            </span>
                          </span>
                        </div>
                      </div>                      
                    </div>   
                    <div class="form-group row">
                      <div class="col-md-6">
                        <yt-dropdown-picklist [ModelName]="'pol'" [GetName]="'get'" [ModelProperty]="'Naziv'" [OrderBy]="'Naziv'"
                          [AllowAddNew]="false" formControlName="PolID" [Label]="'OSOBA.POL.SINGULAR'">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.PolID.invalid">
                          <span *ngFor="let validation of errorMessages.PolID">
                            <span class="error-message" *ngIf="fc.PolID.hasError(validation.type)">
                              <span translate="{{validation.message}}"></span>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <yt-input [Type]="'text'" name="txtJMBG" formControlName="Jmbg" [MaxLength]="13"
                          [ngClass]="{'is-invalid': submitted && fc.Jmbg.invalid}" [Label]="'OSOBA.JMBG.SINGULAR'">
                        </yt-input>
                        <div class="form-error" *ngIf="(fc.Jmbg.invalid && fc.Jmbg.dirty) || (fc.Jmbg.invalid && submitted)">
                          <span *ngFor="let validation of errorMessages.Jmbg">
                            <span class="error-message" *ngIf="fc.Jmbg.hasError(validation.type)">
                              <span translate="{{validation.message}}"></span>
                            </span>
                          </span>
                        </div>
                      </div>                                          
                    </div>
                  </ng-template>
              </ngb-tab>
              <ngb-tab title="{{'OSOBATELEFON.PLURAL'| translate}}/{{'OSOBAEMAIL.PLURAL'| translate}}" id="tbKontakt">
                <ng-template ngbTabContent>
                  <div class="row">
                      <div class="col-md-12">
                          <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[1]" [ParentPropertyName]="'OsobaID'" [ParentPropertyValue]="Item.ID" [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                      </div>
                  </div>
                  <div class="row">
                      <div class="col-md-12">
                          <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'OsobaID'" [ParentPropertyValue]="Item.ID" [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                      </div>
                  </div>
              </ng-template>
              </ngb-tab>
          </ngb-tabset>
      </div>
    </div>
  </div>
</form>